export const projects = [
  {
    id: 1,
    title: 'Kitsu API',
    description:
      '(My first react program) A beginner-friendly React project that uses the public Kitsu API to search and display anime information. It includes features like search by title and shows key details like posters, ratings, and descriptions.',
    images: [
      'https://i.ibb.co/RTx3P9DV/Kitsu-API.jpg',
      'https://i.ibb.co/RTx3P9DV/Kitsu-API.jpg'
    ],
    liveLink: '',
    githubLink: 'https://github.com/LuisDeLeon24/kitsu',
    date: '2024-09-12', 
  },
  {
    id: 2,
    title: 'Red Ciber Segura',
    description: 'A web platform dedicated to supporting victims of cyberbullying by providing a safe space with an AI-powered chat assistant that offers empathetic guidance, crisis support, and personalized safety protocols. The site includes educational resources, confidential reporting tools, and connections to professional help, empowering users to protect themselves and recover in a secure, supportive environment.',
    images: ['https://i.ibb.co/pHFzknH/Red-Cibersegura-1.jpg',
            'https://i.ibb.co/pjDvzJC4/Whats-App-Image-2025-07-10-at-12-38-15-AM.jpg',
            'https://i.ibb.co/8DK07Pt1/Whats-App-Image-2025-07-10-at-12-39-16-AM.jpg',
            'https://i.ibb.co/kZRvkK7/Whats-App-Image-2025-07-10-at-12-40-30-AM.jpg'
    ],
    liveLink: 'https://redcibersegura.netlify.app/',
    githubLink: 'https://github.com/LuisDeLeon24/redCiberSegura.git',
    date: '2025-07-04',
  },
  {
    id: 3,
    title: 'Videntia',
    description: 'Videntia is a web platform that leverages artificial intelligence to analyze images and generate detailed, human-like descriptions of individuals, objects, or scenes. Designed to bridge the gap between visual data and interpretation, it offers powerful tools for automated observation, profiling, and reporting. Videntia serves professionals in security, accessibility, and research, enabling them to see what they see through the lens of AI. See what they see.',
    images: ['https://i.ibb.co/RM48qB4/Whats-App-Image-2025-07-10-at-9-00-47-PM.jpg',
            'https://i.ibb.co/GN9J3H0/Whats-App-Image-2025-07-10-at-9-01-51-PM.jpg',
            'https://i.ibb.co/5dkJGWS/Whats-App-Image-2025-07-10-at-9-07-13-PM.jpg',
    ],
    liveLink: 'https://videntia-999-6d296.web.app/',
    githubLink: '',
    date: '2025-06-21',
  },
  {
    id: 4,
    title: 'Almacenadora',
    description: 'Almacenadora is a comprehensive CRM platform tailored for importers and retail stores, designed to streamline inventory, sales, and client management. Built with React and Chakra UI on the frontend for a sleek, responsive experience, and powered by a Node.js backend within the MERN stack, it delivers robust performance and scalability. Almacenadora simplifies business operations by integrating stock control, order tracking, and customer relationship management into a unified system. Ideal for businesses seeking efficiency and growth, it offers intuitive interfaces and powerful tools to manage every aspect of the supply chain and sales funnel with ease.',
    images: ['https://i.ibb.co/cSkCNsFj/image-6.jpg',
            'https://i.ibb.co/Pvv4rHxz/image-7.jpg',
            'https://i.ibb.co/j9wpwWPK/image-8.jpg',
    ],
    liveLink: 'https://almacenadorafrontend.vercel.app/',
    githubLink: 'https://github.com/LuisDeLeon24/almacenadorafrontend.git',
    date: '2025-06-15',
  },
  {
    id: 5,
    title: 'Hoteles',
    description: 'Hotelera is an advanced CRM platform crafted specifically for the management of hotel chains and hospitality services. Designed to optimize operational workflows, it streamlines room bookings, guest information, service coordination, and revenue tracking within a unified digital environment. Developed with React and Chakra UI on the frontend for a responsive and user-friendly interface, and supported by a robust Node.js backend within the MERN stack, Hotelera ensures performance, scalability, and security. This solution empowers hotel managers to oversee multi-property operations, track guest histories, manage staff tasks, and generate insightful analytics—all from a centralized dashboard. Ideal for growing hotel businesses and franchises, Hotelera offers the tools necessary to enhance guest satisfaction, increase efficiency, and drive strategic decision-making across the entire hospitality ecosystem.',
    images: ['https://i.ibb.co/3t6k1zD/image-9.jpg',
      'https://i.ibb.co/3t6k1zD/image-9.jpg',
    ],
    liveLink: 'https://hoteles-frontend-kappa.vercel.app/events',
    githubLink: 'https://github.com/LuisDeLeon24/Hoteles-frontend.git',
    date: '2025-06-15',
  },
  
 
];
